import React from 'react';

const CategoriesSkeleton: React.FC = () => {
  return (
    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
      {[...Array(6)].map((_, index) => (
        <div key={index} className="bg-white rounded-2xl shadow-sm border border-gray-100 p-6 text-center animate-pulse">
          {/* Icon skeleton */}
          <div className="w-10 h-10 bg-gray-200 rounded-full mx-auto mb-3"></div>
          
          {/* Text skeleton */}
          <div className="h-4 bg-gray-200 rounded w-3/4 mx-auto"></div>
        </div>
      ))}
    </div>
  );
};

export default CategoriesSkeleton;